import { CardSchema } from '../types/schema';
export const formatCurrency = (rawAmount: string | number, currencyCode: string = 'GBP') => {
  if (currencyCode === 'USD') {
    return `$${Number(rawAmount).toFixed(2)}`
  }

  return Number(rawAmount).toLocaleString(undefined, {
    currency: currencyCode,
    style: 'currency'
  });
};

export const formatObscuredCardNumber = (card: CardSchema) => {
  return card.brand + 'xxxxxxxxxxxx' + card.last4
};

export const formatCardExpiry = (card: CardSchema) => {
  const { exp_month, exp_year } = card;
  return (exp_month < 10 ? '0' : '') + exp_month + '/' + exp_year
};

export const formatVAT = (vatRate: string) => {
  return (parseFloat(vatRate) * 100).toFixed(2)
    .replace(/0*$/, '')
    .replace(/\.$/, '') + '%';
};